import { RESET_CHANGE_STATUS_FORM } from '../actionTypes';
import { creditsActions } from '../reducer';

export default () => creditsActions[RESET_CHANGE_STATUS_FORM]();
